import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SortableTable from './components/SortableTable';
import { httpClient, publicBase } from './dataProvider';

export const UserLogList = () => {
    const [userLogs, setUserLogs] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const url = `${publicBase}/user_logs?_end=1000000`; // Fetch all for client-side sort
        httpClient(url)
            .then(({ json }) => {
                console.log('User logs data received:', json); // Debug log
                setUserLogs(json || []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching user logs:', error);
                setLoading(false);
            });
    }, []);

    const columns = [
        {
            key: 'date_time',
            header: 'Date Time',
            render: (record) => new Date(record.date_time).toLocaleString()
        },
        { key: 'user_name', header: 'Name', render: (record) => record.user_name || '-' },
        { key: 'user_surname', header: 'Surname', render: (record) => record.user_surname || '-' },
        { key: 'user_company', header: 'Company', render: (record) => record.user_company || '-' },
        {
            key: 'user_email',
            header: 'User Email',
            render: (record) => record.user_email || '-'
        },
        { key: 'event', header: 'Event' },
        { key: 'description', header: 'Description' },
        {
            key: 'actions',
            header: 'Actions',
            sortable: false,
            filterable: false,
            render: (record) => (
                <Link
                    to={`/users/${record.user_id}/show`}
                    style={{
                        padding: '4px 8px',
                        backgroundColor: '#1976d2',
                        color: 'white',
                        textDecoration: 'none',
                        borderRadius: '4px',
                        fontSize: '12px'
                    }}
                >
                    View
                </Link>
            )
        }
    ];

    if (loading) return <p>Loading...</p>;

    return (
        <div>
            <h2>User Logs</h2>
            <SortableTable data={userLogs} columns={columns} />
        </div>
    );
};
